<script>

export default {
  page: {
    // title: "Progress Container",
    // meta: [
    //   {
    //     name: "Progress Container",
    //   },
    // ],
  },
  components: { },
  props:['userData', 'active'],
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
    }
  },
  filters: {
  },
  mounted(){
    // console.log(this.active)
  },
  methods: {
  },
}
</script>

<template>
  <div>
    <!-- Volunteer -->
    <div
        class="progress-container"
        v-if="userData['user_type_id'] === 4 && !userData.is_mentor"
        >
        <div class="progress-box" :class="{'active': active==='contact-info'}">1</div>
        <div class="progress-box" :class="{'active': active==='questions'}">2</div>
        <div class="progress-box" :class="{'active': active==='faith'}">3</div>
        <div class="progress-box" :class="{'active': active==='additional-details'}">4</div>
        <div class="progress-box" :class="{'active': active==='opportunities'}">5</div>
    </div>

    <!-- Volunteer/Mentor -->
    <div class="progress-container" v-else-if="userData['user_type_id'] === 4 && userData.is_mentor">
        <div class="progress-box" :class="{'active': active==='contact-info'}">1</div>
        <div class="progress-box" :class="{'active': active==='background-check'}">2</div>
        <div class="progress-box" :class="{'active': active==='questions'}">3</div>
        <div class="progress-box" :class="{'active': active==='faith'}">4</div>
        <div class="progress-box" :class="{'active': active==='additional-details'}">5</div>
        <div class="progress-box" :class="{'active': active==='references'}">6</div>
        <div class="progress-box" :class="{'active': active==='opportunities'}">7</div>
    </div>

    <!-- Mentor -->
    <div class="progress-container" v-else>
        <div class="progress-box" :class="{'active': active==='contact-info'}">1</div>
        <div class="progress-box" :class="{'active': active==='background-check'}">2</div>
        <div class="progress-box" :class="{'active': active==='questions'}">3</div>
        <div class="progress-box" :class="{'active': active==='faith'}">4</div>
        <div class="progress-box" :class="{'active': active==='additional-details'}">5</div>
        <div class="progress-box" :class="{'active': active==='references'}">6</div>
    </div>
  </div>
    
</template>